import { NoticeState } from '@src/redux/reducers/notice/notice.interface';
import { RootState } from '@src/redux/interfaces/redux.interface';

export const getNotice = (state: RootState): NoticeState => state.notice;
